export default __webpack_public_path__ + "assets/facilities-2.ed7e4aa5.png";